import React from "react";
import MasterData from "view/settings/masterdata/MasterData";

const ComplianceData = () => {

    const sections = [
        { label: "Status", value: "Status", items: [] },
        { label: "Frequency", value: "Frequency", items: [] },
        { label: "Type Of Obligation", value: "TypeOfObligation", items: [] },
    ];

    return (
        <MasterData pageTitle="Compliance" sections={sections} />
    );
};

export default ComplianceData;